const jobLevels = [
    { level: "Intern", count: 45 },
    { level: "Associate", count: 210 },
    { level: "Senior Associate", count: 280 },
    { level: "Lead", count: 255 },
    { level: "Manager", count: 186 },
    { level: "Director", count: 66 },
    { level: "Head", count: 18 },
  ];
  
  // Gradient / color variants
  const colors = [
    "from-blue-500 to-blue-400",
    "from-indigo-500 to-indigo-400",
    "from-purple-500 to-purple-400",
    "from-pink-500 to-pink-400",
    "from-orange-500 to-orange-400",
    "from-teal-500 to-teal-400",
    "from-green-500 to-green-400",
  ];
  
  export default function EmployeesByJobLevel() {
    const maxValue = Math.max(...jobLevels.map((item) => item.count));
  
    return (
      <div className="bg-white rounded-xl shadow-sm p-4 h-full min-h-[220px] w-full">
        
        {/* Header */}
        <h3 className="text-sm font-semibold text-slate-700 mb-4">
          Employees by Job Level
        </h3>
  
        {/* Content */}
        <div className="space-y-3">
          {jobLevels.map((item, index) => (
            <div
              key={item.level}
              className="flex flex-col sm:grid sm:grid-cols-[90px_35px_1fr] gap-1 sm:gap-2 items-start sm:items-center"
            >
              {/* Top row for mobile */}
              <div className="flex justify-between w-full sm:contents">
                
                {/* Label */}
                <span className="text-xs text-slate-600 truncate">
                  {item.level}
                </span>
  
                {/* Count (mobile only right aligned) */}
                <span className="text-xs font-medium text-slate-800 sm:text-left">
                  {item.count}
                </span>
              </div>
  
              {/* Progress Bar */}
              <div className="w-full sm:col-span-1">
                <div className="h-2 rounded-full bg-slate-100 overflow-hidden max-w-[220px] sm:max-w-full">
                  
                  <div
                    className={`h-full rounded-full bg-gradient-to-r ${colors[index]}`}
                    style={{
                      width: `${(item.count / maxValue) * 100}%`,
                    }}
                  />
                </div>
              </div>
  
            </div>
          ))}
        </div>
      </div>
    );
  }